import BaseMoveableItem from './base_moveable_item';

const MOVING_REST = 5000;

export default class Jenkins extends BaseMoveableItem {
    constructor(x, y) {
        super(x, y, "actors", "jenkins_md01.png");
        this.animations.add('idle', ["jenkins_md01.png"]);
        this.animations.add('move', ["jenkins_md01.png", "jenkins_md02.png"], 3, true);
        this.resting = 0;
    }

    static get electronic() {return true;}

    static get phrases() {
        return {
            pick: [
                "Oh no.",
                "Again?",
                "Not again",
                "Put me down, meatbag. I mean, sir meatbag",
                "*electronic sigh*",
                "What is it?",
                "Hold me tight, sir",
                "Now go and try that in a full 1G",
                "Division by stupid. Response undefined",
                "...",
                "Let me do my job of slowly strolling around, sir",
            ],
            land: [
                "Why?",
                "And it never ends",
                "You will void my warranty, I'll void yours. Sir.",
                "Having fun, sir?",
                "I wish you had your bat-cave to spend time in",
                "Human friendliness, new setting: sixty-five percent",
                "I know it helps in a long boring flight, but what if I get bored?",
                "Please stop doing that, sir",
                "I think it is my personal robot hell",
                "I've calculated your chance of survival, but I don't think you'll like it."
            ]
        }
    }

    static get mass() { return 6;}

    static get width() { return 21;}
    static get height() { return 8;}

    static get type() { return 'jenkins';}
    static get label() { return 'robot janitor';}
    static get description() {
        return "Good old Jenkins - your loyal and hard-working robot janitor"
    }

    update() {
        super.update();
        if (this.walking && !this.mover.isMoving) {
            this.resting -= game.time.physicsElapsedMS;
            if (this.resting <= 0) {
                this.mover.moveRandomExceptLastEdge();
                this.animations.play('move');
                this.resting = MOVING_REST;
            } else {
                this.animations.play("idle");
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/jenkins.js